import { createI18n } from 'vue-i18n'
import messages from './generateMessages'
import Handels from '@/utils/handels.js'

const _Lange = Handels.CurrentLangeuage()
console.log('laguages.Lange.meta==', messages[_Lange], _Lange, messages)

const _Lange_KEY = _Lange + '/' + Handels.GetUrlRelativePath(false).trim()
console.log('laguages.Lange_KEY.meta==', messages[_Lange_KEY], _Lange_KEY, messages)
const finalMesg = Object.assign({}, messages[_Lange], messages[_Lange_KEY])
messages[_Lange] = finalMesg
delete messages[_Lange_KEY]
console.log('messages_res.meta==', messages)
const i18nConfig = {
    legacy: false,
    warnHtmlMessage: false,
    locale: _Lange,
    //locale: 'en-US',
    //fallbackLocale: 'en-US',
    messages,
}

const i18n = createI18n(i18nConfig)
export default i18n